<template>
  <div class="home">
    <div class="login-box">
      <div class="login-img">
        <img src="../../assets/chatimg/loginback.svg">
      </div>
      <div class="login-info">
        <div class="login-info-title">用户登录</div>
        <div class="login-input">
          <div class="login-input-box">
            <div class="login-input-img"><img src="../../assets/chatimg/user.svg"></div>
            <div class="login-input-text"><input type="text" v-model="username" placeholder="请输入你的账号"></div>
          </div>
        </div>
        <div class="login-input">
          <div class="login-input-box">
            <div class="login-input-img"><img src="../../assets/chatimg/lock.svg"></div>
            <div class="login-input-text"><input type="password" v-model="password" placeholder="请输入你的账号"></div>
          </div>
        </div>
        <div class="login-button">
          <van-button class="message-send-submit" :loading="isSend" type="info" loading-text="登录中..." text="登录" @click="login"/>
          <!-- <button @click="login">登陆</button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from 'js-md5';
import { cusLogin, UserInfo, getRongToken } from '@/api/resetApi.js'
export default {
  name: 'shopdetails',
  data() {
    return {
      isSend: false,
      username: '',
      password: '',
      roomid: '',
      cuId: '',
      cuName: '',
      portrait: '',
      sysCode: 'cus',
      nowDate: '',
    }
  },
  created(){
    this.roomid = this.$route.query.roomid
    this.getDate()
    // if (localStorage.getItem('userToken')) {
    //   this.$router.push({
    //     path:'/chat',
    //     query:{
    //       roomid: this.roomid
    //     }
    //   })
    // }
  },
  methods: {
    getDate() {
      var _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let week = new Date().getDay();
      let moth = mm < 10 ? '0' + mm : mm
      let day = dd < 10 ? '0' + dd : dd
      this.nowDate = yy + "-" + moth + "-" + day;
      console.log('nowDate=',this.nowDate)
    },
    login() {
      if (this.username.length === 0) {
        this.$createToast({
          txt: '请输入账户',
          type: 'error'
        }).show()
      } else if (this.password.length === 0) {
        this.$createToast({
          txt: '请输入密码',
          type: 'error'
        }).show()
      } else {
        this.isSend = true;
        this.logindata();
      }
    },
    async logindata() {
      let data = {
        userName: this.username,
        pwd: md5(this.password),
      }
      const res = await cusLogin(data)
      console.log(res)
      try {
        if (res.data.code === 200) {
          localStorage.setItem('userToken', res.data.data)
          this.loginInfo()
        } else {
          this.isSend = false;
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    async loginInfo() {
      const res = await UserInfo()
      console.log(res)
      try {
        if (res.data.code === 200) {
          localStorage.setItem('cuId', res.data.data.cuId)
          localStorage.setItem('cuName', res.data.data.cuName)
          localStorage.setItem('portrait', res.data.data.cuHeadImg)
          this.cuId = res.data.data.cuId
          this.cuName = res.data.data.cuName
          this.portrait = res.data.data.cuHeadImg
          this.loginRongyun()
        } else {
          this.isSend = false;
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    async loginRongyun() {
      let sysCode = md5(this.sysCode)
      let md5str = md5(sysCode + this.nowDate)
      let data = {
        userId: this.cuId,
        sysCode: this.sysCode,
        userName: this.cuName,
        portrait: this.portrait,
        randomSecretkey: md5str,
      }
      const res = await getRongToken(data)
      console.log(res)
      try {
        if (res.data.code === 200) {
          localStorage.setItem('chatToken', res.data.data)
          this.isSend = false;
          this.$router.push({
            path:'/chat',
            query:{
              roomid: this.roomid
            }
          })
        } else {
          this.isSend = false;
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    }
  }
}
</script>

<style lang="scss" scoped>
  .home {
    padding: 60px 0;
    background: linear-gradient(134deg,#225aeb -1%, #037af5 102%);
  }
  .login-box {
    display: flex;
    padding: 120px 0;
    width: 1400px;
    margin: 0 auto;
  }
  .login-img {
    flex: 1;
    align-self: center;
    width: 700px;
    height: 830px;
    overflow: hidden;
    img {
      width: 700px;
      height: 830px;
    }
  }
  .login-info {
    flex: 1;
    align-self: center;
    width: 700px;
    height: 830px;
    background: url(../../assets/chatimg/logininfo.svg);
    // background-size:100% 100%;
    font-size: 0;
    text-align: center;
    .login-info-title {
      padding: 130px 0 120px;
      font-size: 32px;
      font-family: PingFangSC, PingFangSC-Bold;
      font-weight: 700;
      text-align: center;
      color: #333333;
      letter-spacing: 10px;
    }
    .login-input {
      display: inline-block;
      width: 478px;
      height: 72px;
      background: #f8f8f8;
      border: 1px solid #f2f2f2;
      border-radius: 36px;
      margin-bottom: 30px;
      .login-input-box {
        display: flex;
        margin-top: 25px;
        .login-input-img {
          flex: 0 0 24px;
          padding: 0 20px;
          img {
            width: 24px;
            height: 24px;
          }
        }
        .login-input-text {
          flex: 1;
          padding-right: 20px;
          input {
            width: 100%;
            height: 24px;
            font-size: 18px;
            background: #f8f8f8;
          }
        }
      }
    }
    .login-button {
      margin-top: 30px;
      button {
        width: 478px;
        height: 72px;
        background: #0275fe;
        border: 1px solid #f2f2f2;
        border-radius: 36px;
        font-size: 36px;
        font-family: PingFangSC, PingFangSC-Bold;
        font-weight: 700;
        text-align: center;
        color: #ffffff;
        line-height: 72px;
      }
    }
  }
</style>